import {
    GET_ALL_GROUP,
} from './constants';


const initialState = {
    allGroup: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_GROUP: {
            return {
                ...state,
                allGroup: action.payload,
            };
        }
        default:
            return state;
    }
};

